import OAWFTrackDrawer from './src/drawer.vue';
/* istanbul ignore next */
OAWFTrackDrawer.install = function(Vue) {
  Vue.component('oa-wf-track-drawer', OAWFTrackDrawer);
};
export default OAWFTrackDrawer;


// WEBPACK FOOTER //
// ./src/components/oa/view/official/cmps/track_extend/drawer/index.js